// Plain module (no React) holding the latest Firestore templates snapshot, kept up to
// date by TemplatesProvider. Exists because getPdfEmailText is called from deep inside
// pdfReducer.js - a pure reducer with no hook/context access - and needs synchronous
// access to the current templates at dispatch time.
let latestSnapshot = {};

export function setTemplatesSnapshot(map) {
  latestSnapshot = map;
}

export function getTemplatesSnapshot() {
  return latestSnapshot;
}
